import React from 'react'
import { Stack, Box, Skeleton, useTheme, useMediaQuery } from '@mui/material'

const DevicesWidgetSkeleton = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '50%', md: '15%' },
        border: '1px solid #EFEFEF',
        borderRadius: '16px',
        padding: isMobile ? 1.5 : 2,
        backgroundColor: '#FFFFFF',
        minHeight: isMobile ? '50px' : '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Stack spacing={0.5} alignItems="center">
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="text" width={80} height={14} />
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
          <Skeleton variant="text" width={40} height={isMobile ? 24 : 32} />
          <Skeleton variant="text" width={60} height={12} />
        </Stack>
      </Stack>
    </Box>
  )
}

export default DevicesWidgetSkeleton